import { useEffect } from "react";

import DepollutionTable from "../../components/depollution/DepollutionTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function DepollutionList() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Depollution",
      desc: "Vehicles with depollution still in progress",
    });
  }, []);

  return <DepollutionTable />;
}
